import React, { useState, useEffect } from "react";
// import { FieldValue } from "../../../../components/firebase/FirebaseProvider";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import Typography from "@material-ui/core/Typography";
import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@material-ui/core";
// import useStyles from "../style";
// import { useData } from "../../../../components/firebase/DataProvider";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { FieldValue } from "../../../../components/firebase/FirebaseProvider";
import { useData } from "../../../../components/firebase/DataProvider";
import useStyles from "./style";

const ReadMore = ({ children }) => {
  const classes = useStyles();
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <Typography className={classes.desc}>
      {isReadMore ? text?.slice(0, 150) : text}
      <span onClick={toggleReadMore} className={classes.showMore}>
        {isReadMore ? "...lebih banyak" : " lebih sedikit"}
      </span>
    </Typography>
  );
};

function DialogInfaq({
  open,
  handleClose,
  onChange,
  onClick,
  value,
  loadDebounce,
  loadDelivery,
  disabled,
  campaigns,
  onDelete,
}) {
  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });
  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle onClose={handleClose}>{campaigns?.nama}</DialogTitle>
      <DialogContent dividers>
        <TextField
          placeholder={`Tulis nilai ${campaigns?.tipe} disini ... `}
          variant="outlined"
          fullWidth
          onChange={onChange}
          value={value}
        />
        <div>
          <ReadMore>{campaigns?.deskripsi}</ReadMore>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={onDelete}
          disabled={disabled || loadDebounce}
        >
          hapus
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={onClick}
          disabled={disabled || value === undefined || value === ""}
        >
          Simpan
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Infaq({
  subcart,
  alamatId,
  loadDelivery,
  loadDebounce,
  setLoadDebounce,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [infaq, setInfaq] = useState({ nilai: "", disabled: false, error: "" });
  const { campaignsInfaq, cartRef } = useData();

  const handleInfaq = () => {
    setLoadDebounce(true);
    const data = {
      subcarts: {
        [alamatId]: {
          nilai_infaq: parseInt(infaq.nilai),
        },
      },

      updated_at: FieldValue.serverTimestamp(),
    };
    cartRef.set(data, { merge: true });
    setLoadDebounce(false);
    setOpen(false);
  };

  const handleDel = (e) => {
    e.preventDefault();
    setLoadDebounce(true);
    const data_infaq = {
      subcarts: {
        [alamatId]: {
          nilai_infaq: FieldValue.delete(),
        },
      },

      updated_at: FieldValue.serverTimestamp(),
    };
    cartRef.set(data_infaq, { merge: true });
    setLoadDebounce(false);
    setOpen(false);
  };

  useEffect(() => {
    setInfaq({ nilai: subcart?.nilai_infaq });
  }, [subcart?.nilai_infaq]);

  return (
    <>
      <List>
        <ListItem>
          <Button
            disabled={loadDelivery || loadDebounce}
            className={classes.btnInfaq}
            onClick={() => {
              setOpen(true);
              setInfaq((item) => ({
                ...item,
                nilai: subcart?.nilai_infaq,
              }));
            }}
            disableRipple
          >
            <EditIcon fontSize="small" />
            <span className={classes.txtNote}>
              {!subcart?.nilai_infaq
                ? `Tambahkan ${campaignsInfaq[0]?.tipe}`
                : subcart?.nilai_infaq}
            </span>
          </Button>
        </ListItem>
      </List>
      <DialogInfaq
        open={open}
        loadDebounce={loadDebounce}
        loadDelivery={loadDelivery}
        handleClose={() => setOpen(false)}
        onClick={handleInfaq}
        onDelete={handleDel}
        value={infaq.nilai}
        campaigns={campaignsInfaq[0]}
        onChange={(e) => {
          const { value } = e.target;

          setInfaq((item) => ({
            ...item,
            nilai: value.replace(/[^\d]/g, ""),
            disabled: false,
          }));
        }}
      />
    </>
  );
}

export default Infaq;
